// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, "#root .title[data-v-65ecf8de]{color:#031d5b;font-size:24px!important;font-weight:600}#root .description[data-v-65ecf8de]{color:#5b6987;font-size:20px;font-style:normal;font-weight:500;padding-top:18px}#root .main[data-v-65ecf8de]{padding-top:56px}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
